/* eslint-disable no-mixed-operators */
/* eslint react/jsx-pascal-case: 0 */
import * as React from 'react';
import { connect } from 'react-redux';
import { IUserProfile } from '../../../Auth/types';
import { confirmDialog } from '../../../Dialog/actions';
import Constants from '../../../../core/libraries/Constants';
import RbTabs, { IRbTabItem } from '../../../../bosch-react/components/tabs/RbTabs';
import Division from '../Division/Division';
import RbLoadingSpinner from '../../../../bosch-react/components/loading-spinner/RbLoadingSpinner';
import RbLabel, { LabelSize } from '../../../../bosch-react/components/label/RbLabel';
import AdminWrapper from '../../AdminWrapper';
import { RootState } from '../../../../store/store';
import { withRouter } from 'react-router-dom';
import Validation from './Validation';
import AIMReport from './AIMReport';
import DepsReadyForUpdate from '../../DepartmentChanges/DepsReadyForUpdate';
// const DeptMgm_Validation = React.lazy(() => import('../components/DeptMgm_Validation'));
// const DeptMgm_AIMReport = React.lazy(() => import('../components/DeptMgm_AIMReport'));

interface DepartmentsProps {
    userProfile: IUserProfile | undefined,
    confirmDialog: typeof confirmDialog,
    history: any
}

class Departments extends React.Component<DepartmentsProps, any> {

    constructor(props: DepartmentsProps) {
        super(props);
        this.state = {
        };
    }

    async componentDidMount() {
        await this.handleProfileChanged();

    }
    async componentDidUpdate(prevProps: Readonly<DepartmentsProps>, prevState: Readonly<any>, snapshot?: any) {
        if (prevProps.userProfile !== this.props.userProfile) {
            await this.handleProfileChanged();
        }
    }
    handleProfileChanged() {
        const { userProfile } = this.props
        if (!!userProfile) {
            if (userProfile.permissions?.isSuperAdmin === false) {
                this.props.confirmDialog(
                    "No Permission",
                    "You do not have permission to access this page.",
                    true,
                    () => {
                        window.location.href = process.env.REACT_APP_HOME!;
                    }
                );
            }
        }
    }

    render() {
        let element: any = "";
        const items: IRbTabItem[] = [
            {
                label: "Departments Ready For Update",
                content: (
                    <React.Suspense fallback={<RbLoadingSpinner />}>
                        <DepsReadyForUpdate />
                    </React.Suspense>
                )
            },
            {
                label: "Validation",
                content: (
                    <React.Suspense fallback={<RbLoadingSpinner />}>
                        {<Validation />}
                    </React.Suspense>
                )
            },
            {
                label: "AIM Report",
                content: (
                    <React.Suspense fallback={<RbLoadingSpinner />}>
                        <AIMReport />
                    </React.Suspense>
                )
            },
            {
                label: "Division Master",
                content: (
                    <React.Suspense fallback={<RbLoadingSpinner />}>
                        <Division />
                    </React.Suspense>
                )
            }
        ];
        element = (
            !!this.props.userProfile && <AdminWrapper history={this.props.history}>
                <div className="ms-Grid">
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm1" />
                        <div className="ms-Grid-col ms-sm10">

                            <div className="ms-Grid">
                                <div className="ms-Grid-row">
                                    <RbLabel className="header-title" size={LabelSize.Large} >Departments</RbLabel>
                                </div>
                                <div className="ms-Grid-row">
                                    <RbTabs items={items} />
                                </div>
                            </div>

                        </div>
                        <div className="ms-Grid-col ms-sm1" />
                    </div>
                </div>
            </AdminWrapper> || <></>
        );
        return element;
    }

}

const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile
});

export default withRouter(connect(mapStateToProps, { confirmDialog })(Departments));